import CONSTANTS from '../constants';
import { alerts } from './alerts';
import ConfigService from '../services/configService';

export function fetchActivities(skipAuth = false, businessName = null, options = {}) {
    return dispatch => {
        return ConfigService.getActivities(skipAuth, businessName, options).then((response) => {
            dispatch(activitiesAction(response.data));
        }).catch(() => {
            dispatch(alerts.error('Activities not found'));
        });
    };

    function activitiesAction(activities) { return {type: CONSTANTS.ACTIONS.CONFIG.GET.ACTIVITIES, activities: activities} }
}



// WEBPACK FOOTER //
// ./src/actions/configs.js